import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useContext, useEffect, useState } from 'react';
import { CustomButton } from '../../components/buttons';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { AvisFormContext } from './AvisFormContext';

export interface DialogProps {
    onClose: () => void;
}

const AvisFormLegalModal = (props: DialogProps) => {

    const { showLegalTextModal, legalTextLoading, selectedConsentType, legalTexts } = useContext(AvisFormContext);

    const { onClose } = props;

    const [legalText, setLegalText] = useState('');

    useEffect(() => {
        if (showLegalTextModal && legalTexts) {
            const selectedConsent = legalTexts.consents.find(x => x.type === selectedConsentType);
            const selectedContract = legalTexts.contracts.find(x => x.type === selectedConsent?.contractType);
            setLegalText(selectedContract?.text ?? '');
        }
    }, [showLegalTextModal, legalTexts])

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog open={showLegalTextModal} scroll={'paper'} fullWidth={true} maxWidth="sm" onClose={handleClose}>
            <DialogContent>
                {legalTextLoading ? <Box width="100%" display="flex" justifyContent="center"><CircularProgress thickness={5} size={30} /></Box>
                    : <div dangerouslySetInnerHTML={{ __html: legalText }}></div>}
            </DialogContent>
            <DialogActions>
                <CustomButton
                    text="Kapat"
                    variant='text'
                    onClick={handleClose} />
            </DialogActions>
        </Dialog>
    );
}

export default AvisFormLegalModal;